import type { IDropdownListItem } from "@/components/ui/dropdown-list/dropdown-list";

interface DropdownListGroup {
  groupId: string;
  groupLabels: string[];
  items: IDropdownListItem[];
}

/**
 * Filters variable groups based on a search query
 * Searches in both label and detail fields of each item
 *
 * @param groups - Array of variable groups to filter
 * @param searchQuery - Search string to filter by
 * @returns Filtered array of groups containing only matching items
 */
export const filterVariableGroups = (
  groups: DropdownListGroup[],
  searchQuery: string,
): DropdownListGroup[] => {
  if (!searchQuery.trim()) return groups;

  const searchLower = searchQuery.toLowerCase().trim();
  return groups
    .map((group) => ({
      ...group,
      items: group.items.filter(
        (item) =>
          String(item.label || "")
            .toLowerCase()
            .includes(searchLower) ||
          item.detail?.toLowerCase().includes(searchLower),
      ),
    }))
    .filter((group) => group.items.length > 0);
};
